import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.lean-planning')
  .factory('$leanPlans', planObjectFactory);

/* @ngInject */
function planObjectFactory($bringozFactory: $bringozFactory,
                           LeanPlanningAPI: BringozApi,
                           LeanPlanning_DS: DataStoreConfig) {
  function $leanPlans(id: string) {
    return $bringozFactory(id, LeanPlanningAPI, LeanPlanning_DS);
  }

  return $leanPlans;
}
